import type { PublicSlotKey } from '@/apilib';
import type { ContentInjectionApi } from './contentInjectionApi';

export const ContentInjectionApiKey: PublicSlotKey<ContentInjectionApi> = {
  name: 'ContentInjectionApi',
  public: true,
};
